import { useCallback } from "react";
import { useApi } from "../api/context";
import { formatDateTime, timeZoneLabel } from "../lib/format";
import { useDocumentTitle } from "../lib/useDocumentTitle";
import { useLoader } from "../lib/useLoader";
import { useWorkspace } from "./workspace";

export function BookingsPage() {
  useDocumentTitle("Booked calls · TryLook");
  const api = useApi();
  const { tenantId } = useWorkspace();
  const loadBookings = useCallback(() => api.listBookings(tenantId), [api, tenantId]);
  const bookings = useLoader(loadBookings);

  return (
    <>
      <div className="page-head">
        <h1>Booked calls</h1>
        <p>Calls the AI guide booked with your team, with what it learned about each buyer.</p>
      </div>
      <section className="card" data-tour="booked-calls">
        {bookings.error && (
          <p className="alert alert-error" role="alert">
            {bookings.error.message}
          </p>
        )}
        {!bookings.data && !bookings.error && (
          <p className="row muted" role="status">
            <span className="spinner" aria-hidden="true" /> Loading bookings…
          </p>
        )}
        {bookings.data && bookings.data.bookings.length === 0 && (
          <p className="empty">No calls booked yet. Share a demo link or add the embed to get started.</p>
        )}
        {bookings.data && bookings.data.bookings.length > 0 && (
          <div className="table-wrap">
            <table className="data">
              <thead>
                <tr>
                  <th scope="col">When</th>
                  <th scope="col">Buyer</th>
                  <th scope="col">Summary</th>
                  <th scope="col">What we learned</th>
                </tr>
              </thead>
              <tbody>
                {bookings.data.bookings.map((booking) => (
                  <tr key={booking.booking_id}>
                    <td>
                      <div className="cell-primary">{formatDateTime(booking.starts_at)}</div>
                      <div className="muted">
                        {formatDateTime(booking.starts_at, booking.timezone)} ({timeZoneLabel(booking.timezone)})
                      </div>
                    </td>
                    <td>
                      <div className="cell-primary">{booking.prospect_name}</div>
                      <div className="muted">{booking.company ?? booking.prospect_email}</div>
                      {booking.company && <div className="muted">{booking.prospect_email}</div>}
                    </td>
                    <td>{booking.summary}</td>
                    <td>
                      <ul className="chips">
                        {Object.entries(booking.qualification).map(([key, value]) => (
                          <li key={key}>
                            {key.replaceAll("_", " ")}: {value}
                          </li>
                        ))}
                      </ul>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </>
  );
}
